// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"99d1ba56","653":"568a0cc5","750":"acdb54a3"}[chunkId] + ".chunk.css";
};